export default __webpack_public_path__ + "static/media/ic_web_service.d4c54913.svg";